export default __webpack_public_path__ + "static/equilibre_icon_check-827d5be8fd704f6692e8b868298b1060.png";